import admin from './view';

export default [
  {
    path: '/',
    redirect: 'apply',
  },
  {
    path: 'apply',
    redirect: 'apply/new',
  },
  {
    path: 'apply/new', // 신규심사신청
    component: admin('/progress/new'),
  },
  {
    path: 'apply/new/edit/:sq', // 수정
    component: admin('/progress/edit'),
    props: {
      title: '신규심사신청',
      type: 'NEW',
    },
  },
  {
    path: 'apply/new/register', // 등록
    component: admin('/progress/edit'),
    props: {
      title: '신규심사신청',
      type: 'NEW',
    },
  },
  {
    path: 'apply/new/:sq', // 신규심사신청 > 상세조회
    component: admin('/progress/newDetail'),
    props: {
      title: '신규심사신청',
      type: 'NEW',
    },
  },
  {
    path: 'apply/change', // 인증기관변경신청
    component: admin('/progress/change'),
  },
  {
    path: 'apply/change/edit/:sq', // 수정
    component: admin('/progress/edit'),
    props: {
      title: '인증기관변경신청',
      type: 'ACH',
    },
  },
  {
    path: 'apply/change/register', // 등록
    component: admin('/progress/edit'),
    props: {
      title: '인증기관변경신청',
      type: 'ACH',
    },
  },
  {
    path: 'apply/change/:sq', // 인증기관변경신청 > 상세조회
    component: admin('/progress/changeDetail'),
  },

  {
    path: 'apply/transfer', // 기관변경인계요청관리
    component: admin('/progress/transfer'),
  },
  {
    path: 'apply/transfer/:sq', // 기관변경인계요청 > 상세조회
    component: admin('/progress/transferDetail'),
  },
  {
    path: 'apply/regular3Y', // 정기심사신청(3년)
    component: admin('/progress/regular'),
    props: {
      title: '정기 심사신청 (3년)',
      type: 'YR3',
    },
  },
  {
    path: 'apply/regular3Y/edit/:sq', // 수정
    component: admin('/progress/edit'),
    props: {
      title: '정기 심사신청 (3년)',
      type: 'YR3',
    },
  },
  {
    path: 'apply/regular3Y/register', // 등록
    component: admin('/progress/edit'),
    props: {
      title: '정기 심사신청 (3년)',
      type: 'YR3',
    },
  },
  {
    path: 'apply/regular3Y/:sq', // 정기심사신청(3년) > 상세조회
    component: admin('/progress/regularDetail'),
    props: {
      title: '정기 심사신청 (3년)',
      type: 'YR3',
    },
  },
  {
    path: 'apply/regular1Y', // 1년주기공장심사신청
    component: admin('/progress/regular'),
    props: {
      title: '1년주기공장심사신청',
      type: 'YR1',
    },
  },
  {
    path: 'apply/regular1Y/edit/:sq', // 수정
    component: admin('/progress/edit'),
    props: {
      title: '1년주기공장심사신청',
      type: 'YR1',
    },
  },
  {
    path: 'apply/regular1Y/register', // 등록
    component: admin('/progress/edit'),
    props: {
      title: '1년주기공장심사신청',
      type: 'YR1',
    },
  },
  {
    path: 'apply/regular1Y/:sq', // 1년주기공장심사신청 > 상세조회
    component: admin('/progress/regularDetail'),
    props: {
      title: '1년주기공장심사신청',
      type: 'YR1',
    },
  },
  {
    path: 'apply/moving', // 공장이전심사신청
    component: admin('/progress/regular'),
    props: {
      title: '공장이전심사신청',
      type: 'MOV',
    },
  },
  {
    path: 'apply/moving/edit/:sq', // 수정
    component: admin('/progress/edit'),
    props: {
      title: '공장이전심사신청',
      type: 'MOV',
    },
  },
  {
    path: 'apply/moving/:sq', // 공장이전심사신청 > 상세조회
    component: admin('/progress/regularDetail'),
    props: {
      title: '공장이전심사신청',
      type: 'MOV',
    },
  },
  {
    path: 'apply/addItem', // 품목추가신청
    component: admin('/progress/addItem'),
  },
  {
    path: 'apply/addItem/edit/:sq', // 수정
    component: admin('/progress/edit'),
    props: {
      title: '품목추가신청',
      type: 'AIT',
    },
  },
  {
    path: 'apply/addItem/:sq', // 품목추가신청 > 상세조회
    component: admin('/progress/addItemDetail'),
    props: {
      title: '품목추가신청',
      type: 'AIT',
    },
  },
  {
    path: 'apply/addSpec', // 종류·등급·호칭 또는 모델
    component: admin('/progress/addSpec'),
  },
  {
    path: 'apply/addSpec/edit/:sq', // 수정
    component: admin('/progress/edit'),
    props: {
      title: '종류·등급·호칭 또는 모델추가신청',
      type: 'ASP',
    },
  },
  {
    path: 'apply/addSpec/:sq', // 종류·등급·호칭 또는 모델 > 상세조회
    component: admin('/progress/addSpecDetail'),
    props: {
      title: '종류·등급·호칭 또는 모델추가신청',
      type: 'ASP',
    },
  },
  {
    path: 'apply/improve', // 부접합개선조치보고
    component: admin('/progress/improve'),
  },
  {
    path: 'apply/improve/:sq', // 부접합개선조치보고 > 상세조회
    component: admin('/progress/improveDetail'),
  },
  {
    path: 'apply/reExam', // 재심사신청
    component: admin('/progress/reExam'),
  },
  {
    path: 'apply/reExam/:sq', // 재심사신청 > 상세조회
    component: admin('/progress/reExamDetail'),
  },
  {
    path: 'prep', // 심사준비관리
    component: admin('/progress/prep'),
  },
  {
    path: 'prep/:sq', // 심사준비관리 > 상세조회
    component: admin('/progress/prepDetail'),
  },
  {
    path: 'factory', // 공장심사관리
    component: admin('/progress/factory'),
  },
  {
    path: 'factory/:sq', // 공장심사관리 > 상세조회
    component: admin('/progress/factoryDetail'),
  },
  {
    path: 'exam', // 제품심사관리
    component: admin('/progress/exam'),
  },
  {
    path: 'exam/:sq', // 제품심사관리 > 상세조회
    component: admin('/progress/examDetail'),
  },
  {
    path: 'status', // 심사현황
    component: admin('/progress/status'),
  },
  {
    path: 'status/:sq', // 심사현황상세
    component: admin('/progress/statusDetail'),
  },
  {
    path: 'excel', // 엑셀
    component: admin('/progress/excel'),
  },
  { path: '*', redirect: '/404' },
];



// WEBPACK FOOTER //
// ./src/router/admin/progress.js